module.exports = __webpack_public_path__ + "img/star-green.c52f03fa.svg";